import { render, staticRenderFns } from "./Atividades_Component.vue?vue&type=template&id=dcb880b8"
import script from "./Atividades_Component.vue?vue&type=script&lang=js"
export * from "./Atividades_Component.vue?vue&type=script&lang=js"
import style0 from "./Atividades_Component.vue?vue&type=style&index=0&id=dcb880b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports